export default __webpack_public_path__ + "static/media/princess-reversed.56758e4b.svg";